var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0976 19L21 19L21 1L13.0976 1",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.26923C0.447715 9.26923 0 9.71695 0 10.2692C0 10.8215 0.447715 11.2692 1 11.2692L1 9.26923ZM14.1707 10.2692L14.8778 10.9763C15.2684 10.5858 15.2684 9.95265 14.8778 9.56212L14.1707 10.2692ZM9.19439 13.8314C8.80387 14.2219 8.80387 14.855 9.19439 15.2456C9.58492 15.6361 10.2181 15.6361 10.6086 15.2456L9.19439 13.8314ZM10.6086 5.29289C10.2181 4.90237 9.58492 4.90237 9.19439 5.29289C8.80387 5.68342 8.80387 6.31658 9.19439 6.70711L10.6086 5.29289ZM1 11.2692H6.70732L6.70732 9.26923H1L1 11.2692ZM6.70732 11.2692L14.1707 11.2692V9.26923L6.70732 9.26923L6.70732 11.2692ZM10.6086 15.2456L14.8778 10.9763L13.4636 9.56212L9.19439 13.8314L10.6086 15.2456ZM14.8778 9.56212L10.6086 5.29289L9.19439 6.70711L13.4636 10.9763L14.8778 9.56212Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.c86135ee5e32fefd0725264eb0dd05ce.svg";
export { ForwardRef as ReactComponent };